import { SchemaOf, object } from 'yup';
import { AddSurplus } from 'Models/SurplusModels';
import { stringSchema, selectSchema, dateSchema } from 'Common/Validation/BaseSchemas';

export const AddSurplusSchema: SchemaOf<AddSurplus> = object({
	assetId: selectSchema('Current Assets', 1),
	surplusReason: stringSchema('Surplus Reason'),
	surplusDate: dateSchema('Surplus Date'),
});
